.drawer {
  height: 100% !important;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 90px; /* Reserve space for the absolutely positioned footer */
}

.status {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 10px;
  border-radius: 4px;
  background: #f6faff;
  font-size: 14px;
}

.actions {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

.button {
  width: 100%;
}

.drawerFooter {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  width: 100%;
  column-gap: 0.5rem;
  border-top: 1px solid var(--color-neutral-200);
  background-color: #fff;
  padding: 1rem 1.5rem;
}
